import React from 'react'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import store from '../store/store'

export default function Search({ bgColour, titleColour, screenWidth }) {

    const setSearchValue = store((state) => state.setSearchValue)
    const searchValue = store((state) => state.searchValue)
    
    const handleSearch =(e) => {
        const value = e.target.value.toLowerCase()
        setSearchValue(value)
        console.log(value)
    }

    const resetSearch = () => {
        setSearchValue('')
    }

  return (
    <>
    <form id='search_form'>
        <label htmlFor='search_input' className='search_label'>
            <SearchRoundedIcon id='search_logo'/>
        </label>
        
        <input 
            type='text' 
            placeholder='Search for a recipe' 
            id={screenWidth >= 700? 'search_input_large' : 'search_input_small'}
            className={screenWidth >= 700? 'search_input_large' : 'search_input_small'}
            autoFocus={false}
            required={false}
            value={searchValue}
            aria-label='Search for a recipe' 
            aria-required='false' 
            onChange={handleSearch}
        />
        {searchValue !== ''&&
            <ClearRoundedIcon id='search_clear_icon' aria-label="Clear the query" onClick={resetSearch} />
        }
    </form>
    </>
  )
}


/*
<form class="DocSearch-Form">
    <label class="DocSearch-MagnifierLabel" for="docsearch-input" id="docsearch-label">
        <SearchIcon />
        <span class="DocSearch-VisuallyHiddenForAccessibility">Search</span>
    </label>
    <input 
        class="DocSearch-Input" 
        aria-autocomplete="both" 
        aria-labelledby="docsearch-label"
        id="docsearch-input" 
        autocomplete="off" 
        autocorrect="off" 
        autocapitalize="off" 
        enterkeyhint="go" 
        spellcheck="false" 
        placeholder="What are you looking for?" 
        maxlength="64" 
        type="search" 
        value="k" 
        aria-activedescendant="docsearch-item-1" 
        aria-controls="docsearch-list"
    />
    <button type="reset" title="Clear the query" class="DocSearch-Reset" aria-label="Clear the query"></button>
</form>*/
